import axios from 'axios';

export default class psNews {
    constructor(el) {
        if (!el) {
            return;
        }

        this.el = el;
        this.content = this.el.querySelector('#ps-news-list');

        if (!this.content) {
            return;
        }

        this.activeLinkClass = 'ps-news__link-active';
        this.activeContentClass = 'ps-news__active';

        this._initNews();
        this._initFiltering();
    }

    _initNews() {
        const links = this.content.querySelector('.ps-news__links');
        if (!links) {
            return;
        }

        links.addEventListener('click', event => this._toggleNews(event));
        links.addEventListener('keyup', event => {
            // check if Enter key is pressed
            if (event.keyCode === 13) {
                this._toggleNews(event);
            }
        });

        const content = this.content.querySelector('.ps-news__content');
        if (!content) {
            return;
        }

        content.addEventListener('click', event => {
            // Hantera om man trycker p� en aktiv nyhetsyta, men inte p� anchor
            if (event.target.matches('.ps-news__active *') && !(event.target instanceof HTMLAnchorElement)) {
                event.preventDefault();
                const anchor = content.querySelector('.ps-news__active a');
                anchor && anchor.click();
            }
        });
    }

    _initFiltering() {
        const filters = this.el.querySelector('.ps-filter-list');

        if (!filters) {
            return;
        }

        const loader = filters.querySelector('.ajax-loading');

        const toggleLoader = visible => loader.toggleAttribute('hidden', !visible);

        filters.addEventListener('change', async event => {
            if (!(event.target.tagName === 'INPUT' && event.target.type === 'checkbox')) {
                return;
            }

            toggleLoader(true);

            const form = event.target.closest('form');

            try {
                const response = await axios.post(form.action, new FormData(form));
                document.getElementById('ps-news-list').innerHTML = response.data;
            }
            catch (error) {
                this._error(error);
            }

            toggleLoader(false);
        });
    }

    _toggleNews(event) {
        const link = event.target;
        if (!link.classList.contains('ps-news__link')) {
            return;
        }

        const id = link.parentElement.getAttribute('data-id');
        if (!id) {
            return;
        }

        const content = this.content.querySelector('.ps-news__news-block-link[data-id="' + id + '"]');
        if (!content) {
            return;
        }

        // "inaktivera" tidigare nyhet
        const activeLink = this.content.querySelector('.' + this.activeLinkClass);
        const activeContent = this.content.querySelector('.' + this.activeContentClass);
        if (activeLink?.parentElement) {
            activeLink.parentElement.style.background = "transparent";
        }
        activeLink && activeLink.classList.remove(this.activeLinkClass);
        activeContent && activeContent.classList.remove(this.activeContentClass);

        // "aktivera" vald nyhet
        content.classList.add(this.activeContentClass);
        link.classList.add(this.activeLinkClass);
        link.parentElement.style.background = "#fff";
    }

    _error(error) {
        const id = (error && error.response && error.response.status === 401) ? 'ps-logged-out' : 'ps-generic-error';
        alert(document.getElementById(id).value);
    }
}
